import React from "react";
// react-router-dom
import { Link } from "react-router-dom";
// @material-ui
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
// util
import { getTargetStr } from "../../util/util";
// styles
import styles from "./PrevNextArticleStyle";

const useStyles = makeStyles(styles);

export default function PrevNextArticle(props) {
  const classes = useStyles();

  return (
    <div className={classes.prevNextArticleContainer}>
      <Grid container spacing={0}>
        <Grid item xs={12} sm={6} className={classes.padding}>
          <Link
            to={getTargetStr(props.prevArticleURL, props.siteURL)}
            className={classes.link}
          >
            <Grid container className={classes.prevContainer}>
              <Grid item xs={6}>
                <img
                  src={props.prevImgURL}
                  alt="前の記事の画像"
                  className={classes.preNextImg}
                />
              </Grid>
              <Grid item xs={6} className={classes.titleArea}>
                <div>{props.prevTitle}</div>
              </Grid>
            </Grid>
          </Link>
        </Grid>
        <Grid item xs={12} sm={6} className={classes.padding}>
          <Link
            to={getTargetStr(props.nextArticleURL, props.siteURL)}
            className={classes.link}
          >
            <Grid container className={classes.nextContainer}>
              <Grid item xs={6} className={classes.titleArea}>
                <div>{props.nextTitle}</div>
              </Grid>
              <Grid item xs={6}>
                <img
                  src={props.nextImgURL}
                  alt="次の記事の画像"
                  className={classes.preNextImg}
                />
              </Grid>
            </Grid>
          </Link>
        </Grid>
      </Grid>
    </div>
  );
}
